/* globals getFromToDate axios am5 am5themes_Animated */

const charts = document.querySelectorAll('.chart');
const dataCharts = [];

const addDataToChart = (chartElement, chartData, limit) => {
  // Update chart with data
  if (dataCharts.length > 0) {
    dataCharts.forEach((series) => series.data.setAll(chartData));
    return;
  }

  // Texts & colors
  const { unitText, limitText } = chartElement.dataset;
  const [primaryText, primaryBlack, primaryBlue, utilityRed] = [
    '--color-primary-text',
    '--color-primary-black',
    '--color-primary-blue',
    '--color-utility-red',
  ].map((color) => window.getComputedStyle(document.documentElement).getPropertyValue(color).trim());

  const root = am5.Root.new(chartElement);
  // eslint-disable-next-line camelcase
  root.setThemes([am5themes_Animated.new(root)]);

  // Create chart
  // https://www.amcharts.com/docs/v5/charts/xy-chart/
  const chart = root.container.children.push(
    am5xy.XYChart.new(root, {
      panX: true,
      panY: true,
      wheelX: 'panX',
      wheelY: 'zoomX',
      pinchZoomX: true,
    }),
  );

  // Add cursor
  // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
  const cursor = chart.set(
    'cursor',
    am5xy.XYCursor.new(root, {
      behavior: 'none',
    }),
  );
  cursor.lineY.set('visible', false);

  // Create axes
  // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
  const xAxis = chart.xAxes.push(
    am5xy.DateAxis.new(root, {
      baseInterval: {
        timeUnit: 'minute',
        count: 30,
      },
      minGridDistance: 50,
      renderer: am5xy.AxisRendererX.new(root, {}),
      tooltip: am5.Tooltip.new(root, {}),
    }),
  );

  xAxis.get('renderer').grid.template.setAll({
    visible: false,
  });

  // If you need to use biggest value in a chart to set the upper limit
  // const biggestValue = Math.max(...chartData.map((item) => item.value));

  const yAxis = chart.yAxes.push(
    am5xy.ValueAxis.new(root, {
      min: 0,
      max: limit * 2, // biggestValue
      renderer: am5xy.AxisRendererY.new(root, {}),
    }),
  );

  // Add series
  // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
  const series = chart.series.push(
    am5xy.LineSeries.new(root, {
      name: unitText,
      xAxis,
      yAxis,
      valueYField: 'value',
      valueXField: 'date',
      tooltip: am5.Tooltip.new(root, {
        labelText: `{valueY} ${unitText}`,
      }),
      fill: am5.color(primaryBlue),
      stroke: am5.color(primaryBlue),
      curveFactory: d3.curveBasis,
    }),
  );

  // Chart title
  // if (chartElement.dataset.unitText) {
  //   const title = chart.plotContainer.children.push(
  //     am5.Label.new(root, {
  //       text: chartElement.dataset.unitText,
  //       fontSize: 20,
  //       fontWeight: '400',
  //       x: 0,
  //       centerX: 0,
  //     }),
  //   );
  // }

  series.fills.template.setAll({
    fillOpacity: 0.05,
    strokeOpacity: 1,
    visible: true,
  });

  // Add scrollbar
  // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
  chart.set(
    'scrollbarX',
    am5.Scrollbar.new(root, {
      orientation: 'horizontal',
    }),
  );

  // Set data
  series.data.setAll(chartData);
  dataCharts.push(series);

  // add series range
  const seriesRangeDataItem = yAxis.makeDataItem({ value: limit, endValue: limit });
  const seriesRange = series.createAxisRange(seriesRangeDataItem);
  seriesRange.fills.template.setAll({
    fill: am5.color(utilityRed),
    opacity: 1,
    visible: true,
  });

  seriesRangeDataItem.get('grid').setAll({
    stroke: am5.color(utilityRed),
    strokeOpacity: 1,
    visible: true,
  });

  seriesRangeDataItem.get('axisFill').setAll({
    fill: am5.color(utilityRed),
    fillOpacity: 0.05,
    visible: false,
  });

  seriesRangeDataItem.get('label').setAll({
    location: 0,
    visible: true,
    text: limitText,
    inside: true,
    centerX: 0,
    centerY: am5.p100,
    fill: utilityRed,
    fontWeight: 'bold',
  });

  // Make stuff animate on load
  // https://www.amcharts.com/docs/v5/concepts/animations/
  series.appear(1000);
  chart.appear(1000, 100);
};

const mapChartData = (chartElement, apiData) => {
  const urlParams = new URLSearchParams(window.location.search);
  const index = Number(urlParams.get('index')) || Number(chartElement.getAttribute('data-index'));

  let limit = 0;

  let dataArray = Object.keys(apiData).map((key) => apiData[key]);
  dataArray = dataArray.filter((obj) => Object.keys(obj).length > 5);

  const chartData = dataArray.map((item) => {
    const dateObj = item.find((inside) => inside.type === 'date');
    const itemDate = dateObj.value || '';

    const tempDate = itemDate.split(' ')[0].split('.');
    const time = itemDate.split(' ')[1].split(':');
    limit = Number(item[index].limit.replace(',', '.'));

    const date = new Date(tempDate[2], tempDate[1] - 1, tempDate[0], time[0], time[1], time[2]).getTime();
    const valueStr = item[index].value.replace(',', '.');
    const value = item[index].round_number
      ? Math.round(parseFloat(valueStr) || 0)
      : parseFloat(valueStr).toFixed(1) || 0;

    return { date, value };
  });

  addDataToChart(chartElement, chartData, limit);
};

const initChart = () => {
  getMeasurements((apiData) => {
    am5.ready(() => {
      am5.addLicense('AM5C389265151'); // License

      charts.forEach((chartWrapper) => {
        const chart = chartWrapper.querySelector('.chart__inner');
        mapChartData(chart, apiData);
      });
    });
  }, true);
};

if (typeof am5 !== 'undefined' && charts.length > 0) {
  initChart();
}
